import { useOrg } from '@/organization/useOrg';
import { useGetProject } from '@/queries/useProjects';
import { useParams } from 'react-router-dom';

export function usePencilsDown(): boolean {
  const { projectId } = useParams();
  const { selectedOrg } = useOrg();
  const { data: project } = useGetProject(selectedOrg?.id, projectId);
  return project?.pencilsDown === true;
}
